import React from 'react'

const flagColors: Record<string, { bg: string; color: string }> = {
  Urgent: { bg: '#fef2f2', color: '#dc2626' },
  OnHold: { bg: '#fef3c7', color: '#d97706' },
  Withdrawn: { bg: '#f3f4f6', color: '#6b7280' },
  Archived: { bg: '#f3f4f6', color: '#9ca3af' },
  // Feature #223: outcome flags. Green = Successful, magenta-ish = Unsuccessful,
  // blue = TalentPool to mirror the cool tone for "keep warm".
  Successful: { bg: '#ecfdf5', color: '#047857' },
  Unsuccessful: { bg: '#fef2f2', color: '#b91c1c' },
  TalentPool: { bg: '#eff6ff', color: '#1d4ed8' },
}

const flagLabels: Record<string, string> = {
  OnHold: 'On Hold',
  TalentPool: 'Talent Pool',
}

interface StatusFlagBadgeProps { flag?: string | null }

const StatusFlagBadge: React.FC<StatusFlagBadgeProps> = ({ flag }) => {
  if (!flag) return null
  const colors = flagColors[flag] || { bg: '#f3f4f6', color: '#6b7280' }
  return (
    <span style={{
      display: 'inline-block', padding: '3px 8px', borderRadius: '4px',
      fontSize: '11px', fontWeight: 600, backgroundColor: colors.bg, color: colors.color,
    }}>
      {flagLabels[flag] ?? flag}
    </span>
  )
}

export default StatusFlagBadge
